import type { VeivoTheme } from "@veivo/web-sdk";

/**
 * Maps the operator's branding onto the Veivo SDK's Tier 1 theme tokens, so the
 * capture flow looks like the portal it is embedded in rather than like a
 * third-party widget dropped into it.
 *
 * Driven by the OPERATOR's branding, not RideMinder's, because the portal is
 * white-label: an operator with their own colours would otherwise see RideMinder
 * purple appear the moment verification started.
 *
 * `accent` deliberately reuses the operator's primary. It is the success and
 * progress colour (capture flash, walk arrow, captured chips) and reads as "this
 * is working" — which should be the brand colour. `warn` and `danger` are NOT
 * themed: amber and red carry meaning that a brand palette would undermine, and
 * a mis-set danger colour on a rejected capture is actively misleading.
 */
export const veivoThemeFromBranding = (branding?: {
  primary?: string;
  dark?: string;
  light?: string;
}): VeivoTheme => ({
  ...(branding?.primary
    ? { primary: branding.primary, accent: branding.primary }
    : {}),
  // Matches the portal's own card radius so the embedded flow does not look
  // bolted on.
  radius: "8px",
  // Inherit the app's font stack rather than naming one, so a font change in
  // the portal carries into the flow automatically.
  font: "inherit",
});
